import { get, post, put, deleteApi, postForm } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

export const getAllDocNotesByID = (docID, docType) =>
  new Promise((resolve, reject) => {
    // get(APIS.NOTES)
    get(`${APIS.NOTES}?object_type=${docType}&object_id=${docID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllDocNotesService = () =>
  new Promise((resolve, reject) => {
    // get(APIS.NOTES)
    get(`${APIS.NOTES}?object_type=CONTRACT&object_id=1234`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const postNewNoteService = data =>
  new Promise((resolve, reject) => {
    post(APIS.NOTES, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const editNoteService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.NOTES}/${data.id}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteNoteService = noteID =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.NOTES}/${noteID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const uploadAttachmentService = (data, accountID) =>
  new Promise((resolve, reject) => {
    console.debug(data);
    postForm(`${APIS.NOTES}/accounts/${accountID}/attachments`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createMultipleNotes = notesList => {
  try {
    const notesPromises = [];
    notesList.forEach(notes => notesPromises.push(postNewNoteService(notes)));
    Promise.all(notesPromises).then(response => {
      console.debug(response);
    });
  } catch (error) {
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/actions/NotesActions/notesService.js